angular.module('gym.components').directive('reportDateFilterInput', function() {
  return {
    restrict: 'E',
    template: require('templates/components/reports/report_date_filter_input.html.slim'),
    controller: ["$scope", function($scope) {
      var base, base1, base2;
      $scope.relativeDateId = Math.floor(Math.random() * 1000);
      $scope.periods = ['days', 'weeks', 'months', 'years'];
      $scope.onRelativeChange = function() {
        if ($scope.newFilter.relative_date) {
          return $scope.newFilter.user_value = "";
        }
      };
      $scope.multipliers = $scope.disableFromNow ? ['ago'] : ['from_now', 'ago'];
      (base = $scope.newFilter).relative_date || (base.relative_date = false);
      (base1 = $scope.newFilter).multiplier || (base1.multiplier = $scope.multipliers[0]);
      return (base2 = $scope.newFilter).period || (base2.period = $scope.periods[0]);
    }]
  };
});
